import { DownloadSimple, Sparkle } from "@phosphor-icons/react";
import { Mascot } from "../Mascot";

export function FooterSection() {
  return (
    <footer className="relative mt-8 overflow-hidden border-t border-border bg-gradient-to-b from-accent/40 to-background">
      <div className="mx-auto flex w-full max-w-content flex-col items-center gap-6 px-5 py-16 text-center sm:px-8 md:py-20">
        <Mascot size={96} />
        <h2 className="max-w-2xl font-display text-3xl font-black tracking-tight text-balance md:text-4xl">
          A foundation ready to bloom into 50+ screens
        </h2>
        <p className="max-w-xl text-lg font-medium leading-relaxed text-muted-foreground">
          One warm, consistent language — accessible, premium and made to grow with every child from Year 1 to Year 6.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <a
            href="/bloom-design-system.md"
            download
            data-testid="download-spec-btn"
            className="inline-flex min-h-[52px] items-center justify-center gap-2 rounded-full bg-primary px-7 font-display font-bold text-primary-foreground shadow-glow transition-all duration-200 ease-bounce hover:-translate-y-0.5 active:scale-95"
          >
            <DownloadSimple size={20} weight="bold" />
            Download written spec
          </a>
          <span className="inline-flex items-center gap-2 rounded-full border border-border bg-card px-5 py-3 text-sm font-bold text-muted-foreground">
            <Sparkle size={16} weight="fill" className="text-primary" />
            Bloom · Kids Portal Design System
          </span>
        </div>
      </div>
    </footer>
  );
}

export default FooterSection;
